import { render, staticRenderFns } from "./GatewayMapView.vue?vue&type=template&id=2985e65e&"
import script from "./GatewayMapView.vue?vue&type=script&lang=ts&"
export * from "./GatewayMapView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports